import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toasts', () => {
    const messages = ref([])

    function addToast(message) {
        messages.value.push(message)
    }

    function removeToast() {
        messages.value.shift()
    }

    return { messages, addToast, removeToast }
})
